export default __webpack_public_path__ + "static/media/logoAux.c4fdba9d.png";